import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import {
    ApiRequestService,
    FileData,
    FileexplorerComponent,
    FilemanagerService,
    TinyMCEHtmlEditorComponent,
    TranslationPipe
} from '@prekog/common-ui';
import { EmailTemplate } from '../model/email-template.model';
import { EmailService } from '../template-name-translation.service';
import { GetEmailTemplateRequest } from './getemailtemplaterequest';
import { GetEmailTemplateResponse } from './getemailtemplateresponse';
import { UpdateEmailTemplateRequest } from './updateemailtemplaterequest';

@Component({
    selector: 'app-edit-email',
    templateUrl: './edit-email.component.html',
    styleUrls: ['./edit-email.component.scss'],
    standalone: true,
    imports: [
        MatIconModule,
        FormsModule,
        RouterModule,
        TranslationPipe,
        TinyMCEHtmlEditorComponent,
        FileexplorerComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ]
})
export class EditEmailComponent implements OnInit {
    private readonly EMAIL_TEMPLATE_KEY = 'emailTemplate';
    emailTemplate?: EmailTemplate;
    emailUrl = '';
    fileDataList: FileData[] = [];
    getEmailTemplateUrl = '/admin/getEmailTemplate';
    htmlForm?: FormGroup;
    newsLetterForm?: FormGroup;
    readonly separatorKeysCodes = [ENTER, COMMA] as const;
    templateName = '';
    updateEmailTemplateUrl = '/admin/updateemailtemplate';

    constructor(
        @Inject('EMAIL_BACKEND_URL') private _emailUrl: string,
        private _fb: FormBuilder,
        private _apiRequestService: ApiRequestService,
        private _emailService: EmailService,
        private _fileManagerService: FilemanagerService,
        private _router: Router
    ) {
        const navigation = this._router.currentNavigation();

        if (navigation?.extras.state) {
            this.templateName = navigation.extras.state['data'];
        }
        this.emailUrl = _emailUrl;
        this.createHtmlForm();
        this.createNewsLetterForm();
    }

    ngOnInit(): void {
        this.getEmailTemplate();
    }
    getEmailTemplate() {
        if (this.templateName) {
            const getEmailTemplateRequest: GetEmailTemplateRequest = {
                templateName: this.templateName
            };
            this._apiRequestService
                .sendRequest<
                    GetEmailTemplateRequest,
                    GetEmailTemplateResponse
                >(this.emailUrl, getEmailTemplateRequest, true, this.getEmailTemplateUrl)
                .subscribe((response) => {
                    this.emailTemplate = response.emailTemplate!;
                    this.fileDataList = response.attachmentList!;
                });
        }
    }
    createHtmlForm() {
        this.htmlForm = this._fb.group({
            html: ['', [Validators.required]]
        });
    }

    createNewsLetterForm() {
        this.newsLetterForm = this._fb.group({
            subject: ['', [Validators.required]]
        });
    }

    updateEmailTemplate() {
        const updatedEmailTemplate = this.collectEmailTemplateData();
        const updateEmailTemplateRequest: UpdateEmailTemplateRequest = {
            emailTemplate: updatedEmailTemplate,
            fileDataList: this.fileDataList
        };

        this._apiRequestService
            .sendRequest<
                UpdateEmailTemplateRequest,
                HttpResponse<any>
            >(this.emailUrl, updateEmailTemplateRequest, true, this.updateEmailTemplateUrl, true)
            .subscribe(() => {
                this.emailTemplate = { ...this.emailTemplate, ...updatedEmailTemplate };
                sessionStorage.setItem(this.EMAIL_TEMPLATE_KEY, JSON.stringify(this.emailTemplate));
            });
    }

    collectEmailTemplateData(): EmailTemplate {
        const templateName = this.emailTemplate?.templateName;
        const newsletter = this.emailTemplate?.newsletter;
        const emailTemplate: EmailTemplate = {
            subject: this.newsLetterForm?.controls['subject'].value as string | undefined,
            message: this.htmlForm?.controls['html'].value as string | undefined,
            templateName: templateName,
            newsletter: newsletter
        };
        return emailTemplate;
    }

    getTranslatedName(emailTemplate: EmailTemplate): string {
        return this._emailService.getTranslatedName(emailTemplate);
    }

    addAttachment(event: MatChipInputEvent): void {
        const input = event.chipInput?.inputElement;
        const value = (event.value || '').trim();

        if (value) {
            const isDuplicate = this.fileDataList.some((file) => file.url === value);

            if (!isDuplicate) {
                const fileNameFromUrl = value.split('/').pop() || 'Új fájl';

                this.fileDataList.push({
                    url: value,
                    fileName: fileNameFromUrl
                });
            }
        }
        if (input) {
            input.value = '';
        }
    }

    removeAttachment(fileData: FileData): void {
        const index = this.fileDataList.indexOf(fileData);

        if (index >= 0) {
            this.fileDataList.splice(index, 1);
        }
    }

    openFile(url: string): void {
        if (url) {
            window.open(url, '_blank');
        }
    }

    isImage(fileName: string | undefined): boolean {
        return this._fileManagerService.isImage(fileName);
    }
}
